import { COLOR } from './color';
import { nameToToken } from '../utils';
export const BORDER_SIZE = {
    HALF: 0.5,
    MEDIUM: 2,
    THICK: 4,
    THIN: 1,
};
export const BORDER_COLOR = {
    ALTERNATE_CHROMATIC_FOREST: COLOR.CHROMATIC_FOREST_ALTERNATE_MID_TONE,
    ALTERNATE_CHROMATIC_GRAPEFRUITY: COLOR.CHROMATIC_GRAPEFRUITY_ALTERNATE_MID_TONE,
    ALTERNATE_CHROMATIC_LEMONADE: COLOR.CHROMATIC_LEMONADE_ALTERNATE_MID_TONE,
    ALTERNATE_CHROMATIC_PRIMARY: COLOR.CHROMATIC_PRIMARY_ALTERNATE_MID_TONE,
    ALTERNATE_CHROMATIC_STRAWBERRY: COLOR.CHROMATIC_STRAWBERRY_ALTERNATE_MID_TONE,
    ALTERNATE_DEFAULT: COLOR.BORDER_ALTERNATE_DEFAULT,
    ALTERNATE_DISABLED: COLOR.BORDER_ALTERNATE_DISABLED,
    ALTERNATE_EMPHASIS: COLOR.BORDER_ALTERNATE_EMPHASIS,
    ALTERNATE_STRONG: COLOR.BORDER_ALTERNATE_STRONG,
    ALTERNATE_SUBTLE: COLOR.BORDER_ALTERNATE_SUBTLE,
    ALTERNATE_WARM: COLOR.BORDER_ALTERNATE_DISABLED,
    CHROMATIC_FOREST: COLOR.FOREST_5,
    CHROMATIC_GRAPEFRUITY: COLOR.CHROMATIC_GRAPEFRUITY_MID_TONE,
    CHROMATIC_LEMONADE: COLOR.CHROMATIC_LEMONADE_MID_TONE,
    CHROMATIC_PRIMARY: COLOR.CHROMATIC_PRIMARY_MID_TONE,
    CHROMATIC_STRAWBERRY: COLOR.CHROMATIC_STRAWBERRY_MID_TONE,
    DEFAULT: COLOR.BORDER_DEFAULT,
    DISABLED: COLOR.BORDER_DISABLED,
    EMPHASIS: COLOR.BORDER_EMPHASIS,
    STRONG: COLOR.BORDER_STRONG,
    SUBTLE: COLOR.BORDER_SUBTLE,
    WARM: COLOR.BORDER_WARM,
};
export const BORDER = {
    ALTERNATE_CHROMATIC_FOREST: `1px solid ${BORDER_COLOR.ALTERNATE_CHROMATIC_FOREST}`,
    ALTERNATE_CHROMATIC_GRAPEFRUITY: `1px solid ${BORDER_COLOR.ALTERNATE_CHROMATIC_GRAPEFRUITY}`,
    ALTERNATE_CHROMATIC_LEMONADE: `1px solid ${BORDER_COLOR.ALTERNATE_CHROMATIC_LEMONADE}`,
    ALTERNATE_CHROMATIC_PRIMARY: `1px solid ${BORDER_COLOR.ALTERNATE_CHROMATIC_PRIMARY}`,
    ALTERNATE_CHROMATIC_STRAWBERRY: `1px solid ${BORDER_COLOR.ALTERNATE_CHROMATIC_STRAWBERRY}`,
    ALTERNATE_DEFAULT: `1px solid ${BORDER_COLOR.ALTERNATE_DEFAULT}`,
    ALTERNATE_DISABLED: `1px solid ${BORDER_COLOR.ALTERNATE_DISABLED}`,
    ALTERNATE_EMPHASIS: `1px solid ${BORDER_COLOR.ALTERNATE_EMPHASIS}`,
    ALTERNATE_STRONG: `1px solid ${BORDER_COLOR.ALTERNATE_STRONG}`,
    ALTERNATE_SUBTLE: `1px solid ${BORDER_COLOR.ALTERNATE_SUBTLE}`,
    ALTERNATE_WARM: `1px solid ${BORDER_COLOR.ALTERNATE_WARM}`,
    CHROMATIC_FOREST: `1px solid ${BORDER_COLOR.CHROMATIC_FOREST}`,
    CHROMATIC_GRAPEFRUITY: `1px solid ${BORDER_COLOR.CHROMATIC_GRAPEFRUITY}`,
    CHROMATIC_LEMONADE: `1px solid ${BORDER_COLOR.CHROMATIC_LEMONADE}`,
    CHROMATIC_PRIMARY: `1px solid ${BORDER_COLOR.CHROMATIC_PRIMARY}`,
    CHROMATIC_STRAWBERRY: `1px solid ${BORDER_COLOR.CHROMATIC_STRAWBERRY}`,
    DEFAULT: `1px solid ${BORDER_COLOR.DEFAULT}`,
    DISABLED: `1px solid ${BORDER_COLOR.DISABLED}`,
    EMPHASIS: `1px solid ${BORDER_COLOR.EMPHASIS}`,
    STRONG: `1px solid ${BORDER_COLOR.STRONG}`,
    SUBTLE: `1px solid ${BORDER_COLOR.SUBTLE}`,
    WARM: `1px solid ${BORDER_COLOR.WARM}`,
};
export const getCFBorder = (border) => {
    if (!border) {
        return '0';
    }
    const borderToken = nameToToken(border);
    if (Object.keys(BORDER).includes(borderToken)) {
        return BORDER[borderToken];
    }
    return '0';
};
